/** Browser / React Aria noise from aborted view transitions after failed presses. */
export function isIgnorableClientTransitionError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false
  const name = 'name' in err ? String((err as { name?: unknown }).name) : ''
  const message = 'message' in err ? String((err as { message?: unknown }).message) : ''
  if (name === 'InvalidStateError' && /transition was aborted/i.test(message)) return true
  if (name === 'AbortError') return true
  return /transition was aborted because of invalid state/i.test(message)
}
